<template>
    <div class="container-fluid" v-if="tracker && posicao">

        <header-admin :rastreador="tracker" :posicao="posicao" :veiculo="veiculo"></header-admin>

        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="INICIAL">
                <positions-maps :posicao="posicao"/>
            </vk-tabs-item>

            <vk-tabs-item title="COMANDOS" v-if="rastreador">

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="false" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                    <solicitar-posicao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>

            <vk-tabs-item title="PROBLEMAS" v-if="veiculo">
                <problemas  @reload="loadVeiculo($event)" :veiculo="veiculo"></problemas>
            </vk-tabs-item>

            <vk-tabs-item title="VEÍCULO" v-if="veiculo">
                <dados-do-veiculo-admin :veiculo="veiculo"/>
            </vk-tabs-item>


            <vk-tabs-item title="CLIENTE" v-if="cliente">
                <dados-do-cliente-admin :cliente="cliente"/>
            </vk-tabs-item>

            <vk-tabs-item title="RELATÓRIOS" v-if="veiculo">
                <dados-relatorios-admin :veiculo="veiculo"/>
            </vk-tabs-item>


            <vk-tabs-item title="CONFIGURAÇÃO" v-if="config">

                <vk-tabs-vertical keep-alive>

                    <vk-tabs-item title="COMANDO LIVRE" >
                        <comando-livre :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="TEMPOS" >
                        <tempos :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="HBT" >
                        <hbt-concox :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="ÂNGULO" >
                        <angle-concox :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="APN">
                        <apn :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="IP & PORTA">
                        <ip :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="HODOMETRO">
                        <ajustar-hodometro :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                </vk-tabs-vertical>

            </vk-tabs-item>

        </vk-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1>
        </center>
        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="COMANDOS" v-if="rastreador">

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="false" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>

            <vk-tabs-item title="CONFIGURAÇÃO" v-if="config">

                <vk-tabs-vertical keep-alive>

                    <vk-tabs-item title="COMANDO LIVRE" >
                        <comando-livre :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="TEMPOS" >
                        <tempos :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="HBT" >
                        <hbt-concox :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="ÂNGULO" >
                        <angle-concox :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="APN">
                        <apn :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="IP & PORTA">
                        <ip :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="HODOMETRO">
                        <ajustar-hodometro :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                </vk-tabs-vertical>

            </vk-tabs-item>

        </vk-tabs>
    </div>
</template>
<script>
    import {Rastreador, Concox, Veiculo} from '../../class/index';
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import Tempos from './partials/concox/Tempos';
    import Apn from './partials/concox/Apn';
    import Ip from './partials/concox/Ip';
    import Filtro from './partials/concox/Filtro';
    import HeaderAdmin from './HeaderAdmin';
    import EnviarSaidas from '../../components/buttons/EnviarSaidas';
    import MapPosicao from "./partials/MapPosicao.vue";
    import PosicaoAtual from "./partials/PosicaoAtual.vue";
    import TableComandos from "../tables/TableComandos";
    import ComandoLivre from './partials/generico/ComandoLivre.vue';
    import Reset from "../buttons/Reset";
    import AjustarHodometro from './partials/AjustarHodometro.vue';
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';
    import GoogleMapsButton from "../buttons/GoogleMapsButton.vue";
    import GoogleEarthButton from "../buttons/GoogleEarthButton.vue";
    import PositionsMaps from './partials/PositionsMaps.vue';
    import DadosDoVeiculoAdmin from './partials/DadosDoVeiculoAdmin.vue';
    import DadosDoClienteAdmin from './partials/DadosDoClienteAdmin.vue';
    import DadosRelatoriosAdmin from './partials/DadosRelatoriosAdmin.vue';
    import Problemas from '../veiculo/Problemas.vue';
    import HabilitarTensao from '../buttons/HabilitarTensao.vue';
    import BloqueioImediado from '../buttons/BloqueioImediado.vue';
    import BloqueioLento from '../buttons/BloqueioLento.vue';
    import TimeZone from '../buttons/TimeZone.vue';
    import EconomiaHabilitada from '../buttons/EconomiaHabilitada.vue';
    import EconomiaDesabilitada from '../buttons/EconomiaDesabilitada.vue';
    import HbtConcox from './partials/concox/HbtConcox.vue';
    import AngleConcox from './partials/concox/AngleConcox.vue';
    import SleepOneblock from './partials/oneblock/SleepOneblock.vue';
    import TempoParaSleepOneblock from './partials/oneblock/TempoParaSleepOneblock.vue';
    import SolicitarPosicao from '../buttons/SolicitarPosicao.vue';

    export default {
        components: {
            ComandoLivre,
            SolicitarPosicao,
            TempoParaSleepOneblock,
            SleepOneblock,
            AngleConcox,
            HbtConcox,
            EconomiaDesabilitada,
            EconomiaHabilitada,
            TimeZone,
            BloqueioLento,
            BloqueioImediado,
            HabilitarTensao,
            Problemas,
            DadosRelatoriosAdmin,
            DadosDoClienteAdmin, DadosDoVeiculoAdmin,
            PositionsMaps,
            GoogleEarthButton,
            GoogleMapsButton,
            EnviarSaidas, AjustarHodometro,
            HeaderAdmin,
            PosicaoAtual, MapPosicao, TableComandos, Reset,
            SolicitarConfiguracao, Tempos, Apn, Ip, Filtro
        },

        mixins: [
            veiculosAdminMixins
        ],

        data(){
            return {
                config: null,
            }
        },

        async beforeMount(){
            this.config = await Concox.byPK(this.rastreador.id_rastreador);
        },

    }
</script>

<style scoped>
tr.spaceUnder>td {
    padding-bottom: 1em;
}
</style>
